<template>
  <div class="chinword">
    <div class="register-background">
      <div class="paytword-AppTitle">
        <img src="../../public/obraoag/NewCapeReturn.png" alt="" @click="BackLevel()">
        修改登录密码
      </div>
      <div class="register-cephmr register-distce">
        <span>原密码:</span>
        <el-input v-model="chincenr" placeholder="请输入原密码" clearable @input="chinhoer()"></el-input>
      </div>
      <div class="register-cephmr">
        <span>新密码:</span>
        <el-input type="password" v-model="chinloar" placeholder="请输入新密码" clearable show-password @input="chinlord()"></el-input>
      </div>
      <div class="register-cephmr">
        <span>重复密码:</span>
        <el-input type="password" v-model="chinrear" placeholder="请重复新密码" clearable show-password @input="chinreod()"></el-input>
      </div>
      <div class="register-nextsp" @click="chinsern()">保存</div>
    </div>
    <!-- 失败提示 -->
    <div id="warnToast" :style="'display:' + chinfail">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-icon-warn weui-icon_toast"></i>
        <p class="weui-toast__content">{{chintips}}</p>
      </div>
    </div>
    <!-- 成功提示 -->
    <div id="toast" :style="'display:' + chinsucs">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-icon-success-no-circle weui-icon_toast"></i>
        <p class="weui-toast__content">{{chintips}}</p>
      </div>
    </div>
    <TextTips></TextTips>
  </div>
</template>

<script>
import "./obraojs/rem"
export default {
  data () {
    return{
      chincenr: '',
      chinloar: '',
      chinrear: '',
      chinfail: 'none',
      chintips: '',
      chinsucs: 'none',
      loginID: ''
    }
  },
  created () {
    // 从缓存里获取token
    this.loginID = localStorage.getItem("usertoken");
  },
  mounted () {
    
  },
  methods: {
    // 获取用户原密码
    chinhoer(){
      // console.log(this.chincenr);
    },
    // 获取新用户密码
    chinlord(){
      // console.log(this.chinloar);
    },
    // 获取用户重复密码
    chinreod(){
      // console.log(this.chinrear);
    },
    // 点击保存向后台发送修改密码需要的信息
    chinsern(){
      if(this.chincenr == ''){
        this.chintips = '原密码不能为空';
        this.chinfail = 'block';
        const _this = this;
        setTimeout(function(){
          _this.chinfail = 'none';
        },1200)
      }else if(this.chinloar == ''){
        this.chintips = '新密码不能为空';
        this.chinfail = 'block';
        const _this = this;
        setTimeout(function(){
          _this.chinfail = 'none';
        },1200)
      }else if(this.chinrear == ''){
        this.chintips = '重复密码不能为空';
        this.chinfail = 'block';
        const _this = this;
        setTimeout(function(){
          _this.chinfail = 'none';
        },1200)
      }else if(this.chinloar != this.chinrear){
        this.chintips = '新密码和重复密码不一致';
        this.chinfail = 'block';
        const _this = this;
        setTimeout(function(){
          _this.chinfail = 'none';
        },1200)
      }else{
        this.$axios.post('app/updateUserPassword',this.$qs.stringify({
          token: this.loginID,
          oldPassword: this.chincenr,
          newPassword: this.chinloar
        }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
        .then(res => {
          if(res.data.code == '200'){
            localStorage.setItem("password", this.chinloar);
            this.chintips = res.data.msg;
            this.chinsucs = 'block';
            const _this = this;
            setTimeout(function(){
              _this.chinsucs = 'none';
              _this.$router.go(-1);
            },1200)
          }else{
            this.chintips = res.data.msg;
            this.chinfail = 'block';
            const _this = this;
            setTimeout(function(){
              _this.chinfail = 'none';
            },1200)
          }
        })
        .catch(() => {
          console.log('获取失败');
        });
      }
    },
    // 返回上一层
    BackLevel(){
      this.$router.go(-1);
    }
  }
}
</script>

<style scoped>
  @import "obraocs/register.css";
</style>